import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"
import * as Cookies from "js-cookie"

import masterModule from "@/modules/master/stores/index"
import authModule from "@/modules/auth/stores/index"
import settingsModule from "@/modules/settings/stores/index"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    master: masterModule,
    auth: authModule,
    settings: settingsModule
  },

  plugins: [
    /*createPersistedState({
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => {
          value = JSON.parse(value);
          delete value.auth;

          Cookies.set(key, JSON.stringify(value), { expires: 3, secure: true });
        },
        removeItem: key => Cookies.remove(key)
      }
    })*/
  ]
})
